export default ({ request }) => ({
    scmRatingItemsListApi(data) {
        return request({
            url: '/digitalCenter/scmRatingItems/list',
            method: 'post',
            data
        })
    },
    scmRatingItemsListByAppraisalCodeApi(data) {
        return request({
            url: '/digitalCenter/scmRatingItems/listByAppraisalCode',
            method: 'post',
            data
        })
    },
    scmRatingItemsDetailApi(data) {
        return request({
            url: '/digitalCenter/scmRatingItems/detail',
            method: 'post',
            data
        })
    },
    scmRatingItemsSaveApi(data) {
        return request({
            url: '/digitalCenter/scmRatingItems/save',
            method: 'post',
            data
        })
    },
    scmRatingItemsUpdateApi(data) {
        return request({
            url: '/digitalCenter/scmRatingItems/updateStatus',
            method: 'post',
            data
        })
    },
    scmRatingItemsMoveApi(data) {
        return request({
            url: '/digitalCenter/scmRatingItems/move',
            method: 'post',
            data
        })
    }
})
